// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2l6ja","errorLogs":"styles_errorLogs___swML"};